<template>
  <div>
    <div class="wap1">
      <div class="wap1-content">
        <h1 class="title">{{ ourQualifications.titleOne }}</h1>
        <p v-html="ourQualifications.contentOne"></p>
        <!-- <img src="../../assets/images/about/Qualifications.png" alt="" style="width:100%;" /> -->
        <div class="qualifications-box">
          <div class="qualifications-list">
            <img src="../../assets/images/about/qualifications_icon_01.png" style="transform: scaleY(1.35);" />
            <img src="../../assets/images/about/qualifications_icon_08.png" />
            <img src="../../assets/images/about/qualifications_icon_09.png" />
            <img src="../../assets/images/about/qualifications_icon_10.png" />
          </div>
          <div class="qualifications-list" style="margin-bottom: 0;">
            <img src="../../assets/images/about/qualifications_icon_02.png" />
            <!-- <img src="../../assets/images/about/qualifications_icon_03.png" /> -->
            <img src="../../assets/images/about/qualifications_icon_04.png" />
            <img src="../../assets/images/about/qualifications_icon_05.png" />
            <img src="../../assets/images/about/qualifications_icon_06.png" />
            <img src="../../assets/images/about/qualifications_icon_07.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="wap2">
      <div class="wap2-content">
        <h1 class="title">{{ ourQualifications.titleTwo }}</h1>
        <!-- 渲染资质认证数据列表 -->
        <ul class="list_container">
          <li class="list_box" v-for="value,key in commonData[`${currentLang.prefix}enterprise_qualification`]" :key="key">
            <h3 class="list_name">{{ key }}</h3>
            <p class="list_details">{{ value }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { getConfigDataApi } from "@/utils/http.js"


export default {
  data() {
    name: 'Qualifications'

    return {
      commonData: {}
    };
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    ourQualifications() {
      return this.currentLang.config.aboutPage.ourQualifications
    }
  },

  created() {
    this.fetchCommonData();
  },

  methods: {
    fetchCommonData() {
      getConfigDataApi().then(result => {
        if (result.code == 1) {
          this.commonData = result.data
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.qualifications-list {
  margin-bottom: 50px;
  
  img {
    width: 100px;
    height: 100px;
    margin-right: 50px;
  }

  img:last-child {
    margin-right: 0;
  }
}

.wap1 {
  padding-top: 70px;
  padding-bottom: 70px;
  .wap1-content {
    width: 1000px;
    margin: 0 auto 0;
    text-align: center;
    .title {
      font-size: 30px;
      color: #333;
      font-weight: 500;
    }
    p {
      font-size: var(--text-size-bit-larger);
      color: #777;
      line-height: 1.8;
      margin-top: 40px;
      margin-bottom: 60px;
      text-align: justify;
      text-align-last: center;
    }
  }
}
.wap2 {
  padding-top: 80px;
  padding-bottom: 70px;
  background: #f5f5f5;
  
  .wap2-content {
    width: 1200px;
    margin: 0 auto 0;

    .title {
      font-size: 30px;
      color: #333;
      font-weight: 500;
      text-align: center;
      margin-bottom: 60px;
    }

// 资质认证内容
    .list_container {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .list_box {
        width: 48%;
        margin-bottom: 40px;
        h3 {
          color: #003c7a;
          font-weight: 500;
          line-height: 28px;
          margin-bottom: 16px;
        }
        p {
          color: #777;
          font-size: var(--text-size-normal);
          line-height: 1.8;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/about/Qualifications.vue